import { useCallback } from 'react';
import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterOptionKeys,
} from 'shared/types/filter-document';
import { ID } from 'shared/types/id';
import { GroupByMode, SortingMode } from 'shared/types/sorting-mode';
import { TaskPriorityOptions, TaskType } from 'shared/types/task-base';

export const useOnFilterOption = (
  filterDocument: FilterDocument,
  callback: (updatedDocument: FilterDocument) => void,
) => {
  return useCallback(
    (
      idOrOptions:
        | ID
        | { id: ID; value?: string | string[]; min?: number; max?: number },
      value?: string | string[],
    ) => {
      const id = typeof idOrOptions === 'string' ? idOrOptions : idOrOptions.id;
      const val = typeof idOrOptions === 'string' ? value : idOrOptions.value;
      const min = typeof idOrOptions === 'object' ? idOrOptions.min : undefined;
      const max = typeof idOrOptions === 'object' ? idOrOptions.max : undefined;
      const valArray = !val ? null : Array.isArray(val) ? val : [val];
      const updatedDocument = structuredClone(filterDocument);
      updatedDocument.filters ??= {};

      if (id === DocumentOrganizationKeys.SortingMode) {
        updatedDocument.sortingMode =
          (valArray?.[0] as SortingMode | undefined) ?? null;
      }

      if (id === DocumentOrganizationKeys.GroupByMode) {
        updatedDocument.groupByMode =
          (valArray?.[0] as GroupByMode | undefined) ?? null;
      }

      if (id === FilterOptionKeys.LifeArea) {
        updatedDocument.filters[FilterOptionKeys.LifeArea] = {
          include: valArray,
        };
      }
      if (id === FilterOptionKeys.Priority) {
        updatedDocument.filters[FilterOptionKeys.Priority] = {
          include: valArray as TaskPriorityOptions[],
        };
      }
      if (id === FilterOptionKeys.Type) {
        updatedDocument.filters[FilterOptionKeys.Type] = {
          include: valArray as TaskType[],
        };
      }

      if (id === FilterOptionKeys.Tag) {
        updatedDocument.filters[FilterOptionKeys.Tag] = {
          include: valArray,
        };
      }

      if (id === FilterOptionKeys.Goal) {
        updatedDocument.filters[FilterOptionKeys.Goal] = {
          include: valArray,
        };
      }

      if (id === FilterOptionKeys.Duration) {
        updatedDocument.filters[FilterOptionKeys.Duration] = {
          more:
            min !== undefined && min !== null
              ? { type: 'minutes', value: min }
              : null,
          less:
            max !== undefined && max !== null
              ? { type: 'minutes', value: max }
              : null,
        };
      }

      callback(updatedDocument);
    },
    [callback, filterDocument],
  );
};
